import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styles from "./whatsapp.module.scss";
import { isChannelConnected } from "./channelHelpers";
import { useWhatsappChatsHidden } from "../../hooks/useWhatsappChatsHidden";

// ChatSection renders the inline chat entry on /whatsapp. Only visible when
// the branded channel is connected — without it the page user has WhatsApp
// directly on their phone and doesn't need our chat surface. The admin panel
// can also hide chats per branch (access_toggles.whatsapp_chats_hidden).
//
// Phase-6 note: we intentionally link to the existing fullscreen /waba-chats
// route rather than embedding the conversation list+pane on this page. The
// fullscreen view is the chat the team has already shipped and tested; this
// section keeps it discoverable from the WhatsApp config page now that the
// sidebar entry is gone.
const ChatSection = ({ channels }) => {
  const { t } = useTranslation();
  const chatsHidden = useWhatsappChatsHidden();
  if (chatsHidden || !isChannelConnected(channels?.channel_1)) {
    return null;
  }
  return (
    <section className={styles.chatSection}>
      <h2>{t("NSWhatsapp.chatSectionTitle")}</h2>
      <p>{t("NSWhatsapp.chatSectionDesc")}</p>
      <Link to="/waba-chats" className={styles.chatSectionCta}>
        {t("NSWhatsapp.chatSectionOpen")}
      </Link>
    </section>
  );
};

export default ChatSection;
